import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import loadable from '@loadable/component';
import useScreen from 'hooks/useScreen';
import { transformInspirationImageUrl } from '../search-state/utils';
import MasonryPhotoCard from '../photo-card/PhotoCard';
const Masonry = loadable(() => import('../JoybirdMasonry'), {
  ssr: false
});
const MasonryPhotoCardsAlgoliaNext = t0 => {
  const $ = _c(57);
  let hasFilters;
  let hasMore;
  let hits;
  let mobileItemsPerRow;
  let noScrollToView;
  let otherProps;
  let refine;
  let scrollableTarget;
  let searchMore;
  let selectedGridItem;
  let showOnTop;
  let t1;
  let t2;
  let t3;
  let t4;
  let updateSelectedGridItem;
  if ($[0] !== t0) {
    const {
      hasFilters: t5,
      hasMore: t6,
      hits: t7,
      loading: t8,
      mobileItemsPerRow: t9,
      multiSelectedGridItem: t10,
      refine: t11,
      selectedGridItem: t12,
      showOnTop: t13,
      updateHits,
      updateSelectedGridItem: t14,
      variant: t15,
      isSidebarOpen: t16,
      searchMore: t17,
      scrollableTarget: t18,
      noScrollToView: t19,
      ...t20
    } = t0;
    hasFilters = t5;
    hasMore = t6;
    hits = t7;
    t1 = t8;
    mobileItemsPerRow = t9;
    t2 = t10;
    refine = t11;
    selectedGridItem = t12;
    showOnTop = t13;
    updateSelectedGridItem = t14;
    t3 = t15;
    t4 = t16;
    searchMore = t17;
    scrollableTarget = t18;
    noScrollToView = t19;
    otherProps = t20;
    $[0] = t0;
    $[1] = hasFilters;
    $[2] = hasMore;
    $[3] = hits;
    $[4] = mobileItemsPerRow;
    $[5] = noScrollToView;
    $[6] = otherProps;
    $[7] = refine;
    $[8] = scrollableTarget;
    $[9] = searchMore;
    $[10] = selectedGridItem;
    $[11] = showOnTop;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = updateSelectedGridItem;
  } else {
    hasFilters = $[1];
    hasMore = $[2];
    hits = $[3];
    mobileItemsPerRow = $[4];
    noScrollToView = $[5];
    otherProps = $[6];
    refine = $[7];
    scrollableTarget = $[8];
    searchMore = $[9];
    selectedGridItem = $[10];
    showOnTop = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    updateSelectedGridItem = $[16];
  }
  const loading = t1 === undefined ? false : t1;
  const multiSelectedGridItem = t2 === undefined ? null : t2;
  const variant = t3 === undefined ? "" : t3;
  const isSidebarOpen = t4 === undefined ? false : t4;
  const [activeId, setActiveId] = useState(null);
  const {
    isMobile,
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? "2800px" : "2200px";
  if (!hits) {
    return null;
  }
  if (hasFilters && hits.length === 0) {
    if (loading) {
      let t5;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div className="w-full flex items-center justify-center min-h-[20vh]"><div className="text-center"><div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2" role="status" aria-label="Loading" /></div></div>;
        $[17] = t5;
      } else {
        t5 = $[17];
      }
      return t5;
    }
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="w-full flex items-center justify-center min-h-[20vh]">No matches found!</div>;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t5;
  if ($[19] !== hits) {
    t5 = hits && hits.length ? hits.map(_temp) : hits;
    $[19] = hits;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const formattedHits = t5;
  let t6;
  if ($[21] !== activeId || $[22] !== formattedHits || $[23] !== isMobile || $[24] !== mobileItemsPerRow || $[25] !== multiSelectedGridItem || $[26] !== noScrollToView || $[27] !== otherProps || $[28] !== selectedGridItem || $[29] !== showOnTop || $[30] !== updateSelectedGridItem) {
    t6 = formattedHits.map(photo => {
      const finalSelGridItem = multiSelectedGridItem && multiSelectedGridItem[photo.photo_id] ? multiSelectedGridItem[photo.photo_id] : selectedGridItem;
      return <MasonryPhotoCard {...otherProps} active={activeId === photo.photo_id} hits={formattedHits} isMobile={isMobile} key={photo.photo_id} mobileItemsPerRow={mobileItemsPerRow} noScrollToView={noScrollToView ?? true} photo={photo} selectedGridItem={finalSelGridItem} setActiveId={setActiveId} showOnTop={showOnTop} updateSelectedGridItem={updateSelectedGridItem} />;
    });
    $[21] = activeId;
    $[22] = formattedHits;
    $[23] = isMobile;
    $[24] = mobileItemsPerRow;
    $[25] = multiSelectedGridItem;
    $[26] = noScrollToView;
    $[27] = otherProps;
    $[28] = selectedGridItem;
    $[29] = showOnTop;
    $[30] = updateSelectedGridItem;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  const photoCardsList = t6;
  const t7 = photoCardsList.length;
  const t8 = searchMore || refine;
  let t9;
  if ($[32] !== isMobile) {
    t9 = isMobile ? {
      height: "initial",
      overflow: "initial"
    } : {};
    $[32] = isMobile;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  const t10 = variant === "InspirationPage";
  let t11;
  if ($[34] !== t10) {
    t11 = classNames({
      "my-0 -mx-4": t10
    });
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== isMobile || $[37] !== isSidebarOpen || $[38] !== mobileItemsPerRow || $[39] !== photoCardsList || $[40] !== variant) {
    t12 = isMobile ? <div className={classNames("customer-photos-mobile-grid grid gap-[2px] grid-cols-[repeat(auto-fill,minmax(30%,1fr))] w-full", {
      "max-[767px]:!grid-cols-[repeat(auto-fill,minmax(45%,1fr))]": variant === "customer-photos-grid" || mobileItemsPerRow === 2,
      "max-[767px]:!grid-cols-[repeat(auto-fill,minmax(95%,1fr))]": mobileItemsPerRow === 1
    })}>{photoCardsList}</div> : <div className="w-full [&>div]:overflow-hidden"><Masonry photoCardsList={photoCardsList} isSidebarOpen={isSidebarOpen} /></div>;
    $[36] = isMobile;
    $[37] = isSidebarOpen;
    $[38] = mobileItemsPerRow;
    $[39] = photoCardsList;
    $[40] = variant;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== hasMore || $[43] !== infiniteScrollThreshold || $[44] !== photoCardsList.length || $[45] !== scrollableTarget || $[46] !== t11 || $[47] !== t12 || $[48] !== t8 || $[49] !== t9) {
    t13 = <InfiniteScroll dataLength={t7} next={t8} hasMore={hasMore} scrollThreshold={infiniteScrollThreshold} scrollableTarget={scrollableTarget} style={t9} className={t11}>{t12}</InfiniteScroll>;
    $[42] = hasMore;
    $[43] = infiniteScrollThreshold;
    $[44] = photoCardsList.length;
    $[45] = scrollableTarget;
    $[46] = t11;
    $[47] = t12;
    $[48] = t8;
    $[49] = t9;
    $[50] = t13;
  } else {
    t13 = $[50];
  }
  let t14;
  if ($[51] !== hasMore || $[52] !== refine) {
    t14 = hasMore ? <div className="products-grid__load-more"><button type="button" className="text-base [background:none] border-0 text-gray-light1 mt-4 p-2 hover:cursor-pointer hover:text-gray-dark focus-visible:text-gray-dark" onClick={refine}>Load more</button></div> : null;
    $[51] = hasMore;
    $[52] = refine;
    $[53] = t14;
  } else {
    t14 = $[53];
  }
  let t15;
  if ($[54] !== t13 || $[55] !== t14) {
    t15 = <>{t13}{t14}</>;
    $[54] = t13;
    $[55] = t14;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  return t15;
};
MasonryPhotoCardsAlgoliaNext.propTypes = {
  hasFilters: PropTypes.bool,
  hasMore: PropTypes.bool,
  hits: PropTypes.array,
  loading: PropTypes.bool,
  mobileItemsPerRow: PropTypes.number,
  multiSelectedGridItem: PropTypes.object,
  noScrollToView: PropTypes.bool,
  refine: PropTypes.func,
  scrollableTarget: PropTypes.string,
  searchMore: PropTypes.func,
  selectedGridItem: PropTypes.object,
  showOnTop: PropTypes.bool,
  updateHits: PropTypes.func,
  updateSelectedGridItem: PropTypes.func,
  variant: PropTypes.string,
  isSidebarOpen: PropTypes.bool
};
export default MasonryPhotoCardsAlgoliaNext;
function _temp(hit) {
  return {
    ...hit,
    image_link: transformInspirationImageUrl(hit.image_link)
  };
}